export function validateSearchDateRange(start: Date, end?: Date | null) {
    if (end && dayConfig.gregory(end).isSameOrAfter(start)) {
        return end;
    }
    return dayConfig.gregory(start).add(1, 'day').startOf('day').toDate();
}
